import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {OrderComponent} from "../../order-manager/order/order.component";
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';

@Component({
    selector: 'app-reject-order',
    templateUrl: './reject-order.component.html',
    styleUrls: ['./reject-order.component.css'],
    standalone: false
})
export class RejectOrderComponent {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<OrderComponent>,
        public nav: NavBarComponent
    ) {}

    cancelReject() {
        this.dialogRef.close(false);
    }
    rejectOrder() {
        this.dialogRef.close(true);
        this.nav.toggleLoading(true);
    }
}

